var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  fill: "currentColor",
  height: "1em",
  width: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.095 12.892L6.79 7.103 1.095 1.221m11.822 11.671L7.223 7.103l5.694-5.882",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));
export default SvgCloseIconcom;